import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/lib/Modal';
import { Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { searchForOpportunities } from 'services/entities/duck';
import PrimaryButton from 'components/atoms/buttons/compact/Primary';
import TextInput from 'components/atoms/inputs/TextInput';
import loadingGif from 'assets/loading.gif';
import LoadingImage from 'components/atoms/LoadingImage';

const ResultBox = styled.div`
    min-height: 100px;    
    max-height: 425px;
    overflow-y: scroll;
    border-style: solid;
    border-width:  1px;
    padding: 1rem;
    ul.results:not(:first-child) {
        border-top: 2px solid;
    }
`;
const ResultList = styled.ul`
    list-style-type: none;
    padding: 1rem;
    :hover{
        background-color: #DDF0F9;
    }
`;
const ResultSubItem = styled.li`
    padding: 0.25rem;
`;
const ResultSubItemLabel = styled.label`
    font-weight: bold;
    padding-right: 1rem;
`;
const LoadingBox = styled.div`
    justify-content: center;
    display: grid;
`;

const ResultItem = props => (
    <ResultList className="results">
        <ResultSubItem><ResultSubItemLabel>Name:</ResultSubItemLabel>{props.opportunity.name}</ResultSubItem>
        <ResultSubItem>
            <ResultSubItemLabel>Advertiser:</ResultSubItemLabel>
            {props.opportunity.accountName}</ResultSubItem>
        <ResultSubItem>
            <Row style={{ fontSize: '1.2rem' }}>
                <Col xs={5}><ResultSubItemLabel>Id:</ResultSubItemLabel> {props.opportunity.id}</Col>
                <Col xs={5}><ResultSubItemLabel>Created:</ResultSubItemLabel> {moment(props.opportunity.createdDate).format('MM-DD-YYYY h:mm A')}</Col>
            </Row>
        </ResultSubItem>
        <ResultSubItem style={{ textAlign: 'center' }}>
            <PrimaryButton onClick={() => props.onClick(props.opportunity.id)}>Select</PrimaryButton>
        </ResultSubItem>
    </ResultList>);

const SearchOpportunities = (props) => {
    const [currentSearchInput, setCurrentSearchInput] = useState('');

    const changeFieldValue = ({ target: { value } }) => {
        setCurrentSearchInput(value);
        props.searchForOpportunities({ searchInput: value });
    };

    const {
        title = 'Search for Opportunities',
        proceed,
        opportunitiesFound,
        isWaiting,
        lastSearchInput,
        dismiss,
        enableEscape = true,
    } = props;

    const isInProgress = isWaiting ||
        (currentSearchInput
            && lastSearchInput
            && (lastSearchInput !== currentSearchInput));
    const startingInputValue = currentSearchInput || lastSearchInput;
    return (
        <Modal style={{ top: '10%' }} show={true} onHide={dismiss} backdrop={enableEscape ? true : 'static'} keyboard={enableEscape}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TextInput input={{
                    value: startingInputValue || '',
                    autoFocus: true,
                    onChange: changeFieldValue
                }} />

                {
                    <ResultBox>
                        {isInProgress && <LoadingBox><LoadingImage src={loadingGif} alt='loading...' /></LoadingBox>}
                        {
                            (!isInProgress && !startingInputValue)
                            && <p>Enter the name of the Opportunity or Advertiser.</p>
                        }
                        {
                            (!isInProgress
                                && opportunitiesFound
                                && opportunitiesFound.length === 0
                                && startingInputValue)
                            && <p>No matching Opportunities found.</p>
                        }
                        {
                            opportunitiesFound
                            && Boolean(opportunitiesFound.length)
                            && opportunitiesFound
                                .map(opp => <ResultItem key={opp && opp.id} onClick={proceed} opportunity={opp} />)}
                    </ResultBox>
                }
            </Modal.Body>
        </Modal>
    );
};

SearchOpportunities.propTypes = {
    title: PropTypes.string,
    proceed: PropTypes.func, // called when selection is made.
    dismiss: PropTypes.func, // called when backdrop is clicked or escaped.
    enableEscape: PropTypes.bool,
};

const mapStateToProps = (state => ({
    opportunitiesFound: state.entities.searchForOpportunitiesResults,
    isWaiting: state.entities.searchForOpportunitiesIsWaiting,
    lastSearchInput: state.entities.searchForOpportunitiesSearchInput,
    currentUser: state.users.currentUser
}));

export default compose(
    connect(mapStateToProps, {
        searchForOpportunities
    }))(SearchOpportunities);



// WEBPACK FOOTER //
// ./src/components/molecules/modal/SearchOpportunities.js